/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import axios from 'axios';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import _ from 'lodash';
import * as ActionTypes from './actionTypes';
import { NO_DATA } from '../../../../SharedModules/Errors/constantMessageData';

export const dispatchPlanType = (data) => ({
  type: ActionTypes.GET_PLAN_TYPE_DATA,
  payload: data,
});

export const getPlanTypeValues = () => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(serviceEndPoint.GET_COMMON_MANUFACUTRE_DROPDOWNS, {
      codeDomainList: ['PLAN_TYPE_CD'],
    })
    .then((response) => {
      dispatch(setLoading(false));
      return dispatch(dispatchPlanType(response.data));
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch(dispatchPlanType([]));
    });
};

//API to get Reabte Program List
export const getRebateProgrameList = (value) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(`${serviceEndPoint.SYSTEM_LIST_ALL_DROPDOWN}`, { planType: value })
    .then((response) => {
      dispatch(setLoading(false));
      return response.data.data;
    })
    .catch((response) => {
      dispatch(setLoading(false));
    });
};

export const setSearchInput = (data) => ({
  type: ActionTypes.SET_SELECTED_CHIP_CSHCN_RATE_AUDIT,
  payload: data,
});

//Loader
export const setLoading = (value) => ({
  type: ActionTypes.IS_LOADING_ADJUSTMENT_CHIP_CSHCN_RATES,
  isLoading: value,
});

//Get max qtr + 1
export const getChipCshcnRatesMaxQtr = (values) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(`${serviceEndPoint.GET_MAX_QTR_CHIP_CSHCN}`, values)
    .then((response) => {
      dispatch(setLoading(false));
      return dispatch({
        type: ActionTypes.GET_CHIP_CSHCN_RATE_AUDIT_MAX_QUARTER,
        chipCshcnMaxQuarter: response.data.data,
      });
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch([]);
      return response;
    });
};

//Manufacturer Grid
export const getManufacturerList = (values) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(
      `${serviceEndPoint.REBATE_PERCENT_OF_SPEND_MANUFACTURER_GRID}`,
      values
    )
    .then((response) => {
      dispatch(setLoading(false));
      return dispatch({
        type: ActionTypes.GET_MANUFACTURER_LIST_CHIP_CSHCN_RATES,
        manufacturerList: response.data,
      });
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch([]);
      return response;
    });
};

//To get the defaut selection on the req screen when reopening the req screen
export const refreshChipCshcnRateAudit = () => ({
  type: ActionTypes.REFRESH_CHIP_CSHCN_RATE_AUDIT,
  payload: {},
});
export const refreshChipCshcnRateAuditDisplay = () => ({
  type: ActionTypes.REFRESH_CHIP_CSHCN_RATE_AUDIT_DISPLAY,
  payload: {},
});
// This action show error message for 5 sec for no contract exists
export const showNoDataMessage = () => (dispatch) => {
  // setTimeout(() => {
  //   dispatch(setSearchInput({ errors: [] }));
  // }, 5000);
  dispatch(
    setSearchInput({
      errors: [
        {
          field: 'noData',
          message: NO_DATA,
        },
      ],
    })
  );
};

export const setChipCshcnReport = (data) => ({
  type: ActionTypes.GET_RESULT_CHIP_CSHCN_RATE_AUDIT,
  searchResult: data,
});

//Result Grid
export const getResultGridChipCshcnRateAudit = (values) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(`${serviceEndPoint.GET_CHIP_CSHCN_RATE_AUDIT_GRID}`, values)
    .then((response) => {
      dispatch(setLoading(false));
      if (response?.data?.chipCshcnRateAuditReportVO.length === 0) {
        dispatch(showNoDataMessage());
      } else {
        return dispatch(
          setChipCshcnReport(response?.data?.chipCshcnRateAuditReportVO)
        );
      }
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch(setChipCshcnReport([]));
      // return response;
    });
};
